import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/common/Navbar";
import ContactBanner from "../../assets/images/banner/earring.jpg";
import BannerSection from "../../components/common/BannerSection";
import { useInView } from 'react-intersection-observer';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
    useEffect(() => window.scrollTo(0, 0), []);
    const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref5, inView5] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref6, inView6] = useInView({ triggerOnce: true, threshold: 0.1 });
    return (
        <div>
            <Helmet><title>Privacy Policy</title></Helmet>
            <Navbar inner={true} />
            <BannerSection
                Banner={ContactBanner}
                title={"Privacy Policy"}
                subtitle={"Protecting client data, ensuring transparency, and safeguarding privacy rights."}
            />
            <div className="site-content">
                <section className="space-pt z-index-2">
                    <div className="container">
                        <div className="pb-4 privacy-poly">
                            <h1 className="privacy-header">Privacy Policy for Maa vaishno jewellers</h1>
                            <p class="policy-text">At Maavaishno Jewellers, we value your privacy and are committed to protecting your personal information.
                            </p>
                        </div>
                        <div className="pb-4">
                            <h3 className="privacy-header">1. Information We Collect</h3>
                            <p>We may collect the following information:</p>
                            <ul>
                                <li>Name</li>
                                <li>Contact information including email and phone number</li>
                                <li>Billing and shipping address</li>
                                <li>Payment details (processed securely via third-party providers)</li>
                            </ul>
                            <h3 className="privacy-header">2. How We Use Your Information</h3>

                            <p>We use your information to:</p>
                            <ul>
                                <li>Process orders and transactions</li>
                                <li>Improve our products and services</li>
                                <li>Send promotional emails or offers (with your consent)</li>
                                <li>Provide customer support</li>
                            </ul>
                            <h3 className="privacy-header">3. Data Protection</h3>

                            <p>We implement appropriate security measures to protect your data from unauthorized access or disclosure.</p>

                            <h3 className="privacy-header">4. Cookies</h3>

                            <p>Our website may use cookies to enhance user experience. You can choose to disable cookies through your browser settings.</p>

                            <h3 className="privacy-header">5. Third-Party Services</h3>

                            <p>We may use third-party services for:</p>
                            <ul>
                                <li>Payment processing</li>
                                <li>Shipping and logistics</li>
                                <li>Analytics</li>
                            </ul>
                            <p>These providers have their own privacy policies governing the use of your data.</p>

                            <h3 className="privacy-header">6. Sharing of Information</h3>

                            <p> We do not sell, trade, or rent your personal information to third parties except as required for order fulfillment or legal compliance.</p>

                            <h3 className="privacy-header">7. Your Rights</h3>

                            <p>You have the right to:</p>
                            <ul>
                                <li>Access your personal data</li>
                                <li>Request correction or deletion of your data</li>
                                <li>Opt-out of marketing communications</li>
                            </ul>
                            <h3 className="privacy-header">8. Changes to Policy</h3>

                            <p>We may update this policy from time to time. Changes will be posted on this page.</p>

                            <h3 className="privacy-header">9. Contact Us</h3>

                            <p>If you have any questions regarding this Privacy Policy, please contact us:</p>

                            Email: <a href="mailto:maavaishnoojewellers@gmail.com" style={{ color: "#efd7a9" }}>maavaishnoojewellers@gmail.com</a>
                            <br />  Phone: <a href="mailto:+917011967851" style={{ color: "#efd7a9" }}>+91 70119 67851</a>
                            <br /> Address: Ward No 24, Lal Bazar, Bettiah, West Champaran, Bihar, 845438
                        </div>
                    </div>
                </section>

            </div>
        </div>
    );
};

export default PrivacyPolicy;
